<template>
    <div>
        <ion-toggle
            :class="toggleClass"
            slot="start"
            @ionChange="$emit('input', $event.detail.checked)"
            :value="value"
            :checked="value"
            :disabled="disabled"
            @ionBlur="$emit('ionBlur', $event)"
        ></ion-toggle>
        <input-error :id="id"></input-error>
    </div>
</template>

<script>
import InputError from "./InputError";

export default {
    components: {
        InputError
    },
    props: {
        value: {
            required: true
        },
        id: {
            type: String,
            required: true
        },
        disabled: {
            required: false
        },
        toggleClass: {
            required: false
        }
    }
};
</script>

<style lang="scss" scoped>
ion-toggle {
    --handle-background-checked: var(--ion-color-light);
    &.-geld {
        --background-checked: rgba(var(--gangl-color-geld-rgb), 0.7);
    }
    &.-gesundheit {
        --background-checked: rgba(var(--gangl-color-gesundheit-rgb), 0.7);
    }
    &.-mobilitaet {
        --background-checked: rgba(var(--gangl-color-mobilitaet-rgb), 0.7);
    }
    &.-wohnen {
        --background-checked: rgba(var(--gangl-color-wohnen-rgb), 0.7);
    }
    &.-zukunft {
        --background-checked: rgba(var(--gangl-color-zukunft-rgb), 0.7);
    }
    &.-berater {
        --background-checked: rgba(var(--gangl-color-berater-rgb), 0.7);
    }
    &.-karriere {
        --background-checked: rgba(var(--gangl-color-karriere-rgb), 0.7);
    }
}

.md {
    ion-toggle {
        --handle-background-checked: var(--ion-color-light);
        &.-geld {
            --handle-background-checked: var(--gangl-color-geld);
        }
        &.-gesundheit {
            --handle-background-checked: var(--gangl-color-gesundheit);
        }
        &.-mobilitaet {
            --handle-background-checked: var(--gangl-color-mobilitaet);
        }
        &.-wohnen {
            --handle-background-checked: var(--gangl-color-wohnen);
        }
        &.-zukunft {
            --handle-background-checked: var(--gangl-color-zukunft);
        }
        &.-berater {
            --handle-background-checked: var(--gangl-color-berater);
        }
        &.-karriere {
            --handle-background-checked: var(--gangl-color-karriere);
        }
    }
}
</style>
